export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/es.lyaml"));
vm(require("feature-monetization/lang/es.lyaml"));
at({ "es": { "publicPricingPage": { "windowTitles": { "default": "Precios | HubSpot" } } } });
};